var load = {
	getJson: function(url,params){
		var defer 	= $.Deferred();
		var url 	= url;
		$.ajax({
			type: "GET",
			dataType: 'json',
			url: url,
			data: params,
			success	: defer.resolve,
			error: defer.reject
		});
		return defer.promise();
	},
	postJson: function(url, params){
		var defer 	= $.Deferred();
		var url 	= url;
		$.ajax({
			type: "POST",
			dataType: 'json',
			url: url,
			data: params,
			success	: defer.resolve,
			error: defer.reject
		});
		return defer.promise();
	}
}